module.exports = {"450512100":"南康镇","450512101":"营盘镇","450512102":"兴港镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450512.json
// module id = 2246
// module chunks = 0